import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Required Stepper|Name Confirmation|`;

const sharedProps = {
	feature: HubFeature.CandidateAccess,
	portal: 'CP' as LocPortal,
	shared: false,
};

type LocNameStart = 'CPNameConfirmationForm';
export type CPNameConfirmationFormLoc =
	| `${LocNameStart}FirstNameQuestionMark`
	| `${LocNameStart}LastNameQuestionMark`;

export const cpNameConfirmationFormLocs: LocDefs<CPNameConfirmationFormLoc> = {
	CPNameConfirmationFormFirstNameQuestionMark: {
		defaultValue: 'First name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: `${dpRoot}First Name|Question Marks`,
		displayType: 'Error',
		...sharedProps,
	},
	CPNameConfirmationFormLastNameQuestionMark: {
		defaultValue: 'Last name must not contain only question marks',
		description: 'Error displayed when there are only question marks in the field',
		displayPath: `${dpRoot}Last Name|Question Marks`,
		displayType: 'Error',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<CPNameConfirmationFormLoc>(cpNameConfirmationFormLocs);
export type CPNameConfirmationFormLocType = LocMap<CPNameConfirmationFormLoc>;
